export default __webpack_public_path__ + "static/media/Central African Republic.c7843bdf.png";